import { Button } from "@/components/ui/button";

type LoadMoreButtonProps = {
  onLoadMore: () => void;
  loading?: boolean;
  hasMore?: boolean;
  error?: Error | null;
  onRetry?: () => void;
};

export const LoadMoreButton = ({
  onLoadMore,
  loading = false,
  hasMore = false,
  error = null,
  onRetry,
}: LoadMoreButtonProps) => {
  // Show error state
  if (error) {
    return (
      <div className="flex flex-col items-center gap-4 py-8">
        <div className="flex flex-col items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div className="text-sm text-red-600 font-medium">Failed to load more comments</div>
        </div>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry} className="text-red-600 border-red-200 hover:bg-red-50">
            Try Again
          </Button>
        )}
      </div>
    );
  }

  // Show end state when no more content
  if (!hasMore) {
    return <></>;
  }

  // Show load more button
  return (
    <div className="flex flex-col items-center gap-3">
      <Button variant="link" size="default" onClick={onLoadMore} disabled={loading} className="min-w-32">
        {loading ? (
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-gray-600" />
        ) : (
          "もっと見る"
        )}
      </Button>
    </div>
  );
};
